<template>

  <van-cell-group>
    <van-cell icon="manager-o" center title-class="titleClass" size="large" title="名称" :value="usInfo.name" />
    <van-cell icon="location-o" center title-class="titleClass" value-class="valueClass" size="large" title="地址" :value="usInfo.adddress" />
    <van-cell icon="phone-o" center title-class="titleClass" size="large" title="电话" :value="usInfo.phone" />
    <van-cell icon="envelop-o" center title-class="titleClass" size="large" title="邮箱" :value="usInfo.email" />
  </van-cell-group>

</template>





<script>
import aboutusConfig from "../../config/aboutus.config";
export default {
  name: "aboutus",
  data() {
    return {
      usInfo: aboutusConfig
    };
  },
  methods: {}
};
</script>


<style scoped lang="scss">
.titleClass {
  text-align: left;
  height: 4rem;
  line-height: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/view/person/aboutus.vue